import React, { useContext } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import ContentContext from "../../contexts/ContentContext";
import { getMetadatas, getMetaValues } from "../../utils/data/metadata";
import { getTranslatedMetadata } from "../../utils/data/Content";

function TabContentMetaLanguages() {
  const { t } = useTranslation("editor-content");

  const { item, isDisabled, metadatas, onItemUpdate, languageId } =
    useContext(ContentContext);

  const handleKeyUpdate = (selection, key) => {
    const updatedKey = Array.isArray(selection)
      ? selection?.map((selectionItem) => selectionItem.data)
      : selection?.data;

    onItemUpdate({
      ...item,
      [key]: updatedKey || null,
    });
  };
  return (
    <>
      <div className="editor-form-section" id="languagesAnchor">
        <div className="editor-form-section-title">{t("nationalities")}</div>
        <div className="editor-form-input" style={{ maxWidth: "500px" }}>
          <Select
            name="form-field-name"
            isDisabled={isDisabled}
            closeMenuOnSelect
            value={getMetaValues({ metadata: item.nationalities, languageId })}
            onChange={(selection) =>
              handleKeyUpdate(selection, "nationalities")
            }
            options={getMetadatas({
              metadatas,
              type: "nationalities",
              languageId,
              withTranslations: true,
            })}
            placeholder={t("select")}
            isMulti
            className="editor-select"
            classNamePrefix="slct"
          />
        </div>
      </div>
      <div className="editor-form-section">
        <div className="editor-form-section-title">{t("original_version")}</div>
        <div className="editor-form-input" style={{ maxWidth: "500px" }}>
          <Select
            name="form-field-name"
            isDisabled={isDisabled}
            closeMenuOnSelect
            value={
              item.original_ver
                ? {
                    value: item.original_ver.uuid,
                    label: getTranslatedMetadata(
                      item.original_ver,
                      "title",
                      languageId,
                    ),
                  }
                : null
            }
            onChange={(selection) => handleKeyUpdate(selection, "original_ver")}
            options={getMetadatas({
              metadatas,
              type: "languages",
              languageId,
              withTranslations: true,
            })}
            placeholder={t("select")}
            isClearable
            className="editor-select"
            classNamePrefix="slct"
          />
        </div>
      </div>
      <div className="editor-form-section section-separator">
        <div className="editor-form-section-title">{t("lang_availables")}</div>
        <div className="editor-form-input" style={{ maxWidth: "500px" }}>
          <Select
            name="form-field-name"
            isDisabled={isDisabled}
            closeMenuOnSelect
            value={getMetaValues({
              metadata: item.lang_availables,
              languageId,
            })}
            onChange={(selection) =>
              handleKeyUpdate(selection, "lang_availables")
            }
            options={getMetadatas({
              metadatas,
              type: "languages",
              languageId,
              withTranslations: true,
            })}
            placeholder={t("select")}
            isMulti
            className="editor-select"
            classNamePrefix="slct"
          />
        </div>
      </div>{" "}
    </>
  );
}

export default TabContentMetaLanguages;
